import { ColorDot } from "~/components/charts";
import { Text } from "~/components/text";

export const MetricColumn = ({
  colorClassName,
  description,
  available,
  value,
}: {
  colorClassName: string;
  description: string;
  available: boolean;
  value: string;
}) => (
  <div className="flex min-w-0 flex-1 flex-col gap-1 px-4 first:pl-0 last:pr-0">
    <Text
      as="span"
      variant="metricCaption"
      className="inline-flex items-center gap-1.5"
    >
      <ColorDot className={colorClassName} shape="round" />
      {description}
    </Text>
    <Text
      as="span"
      variant={available ? "heading" : "headingMuted"}
      numeric="tabular"
      className="truncate"
    >
      {value}
    </Text>
  </div>
);
